import Core6Utilities from './Core6Utilities';

export default class Core6Component {
  constructor() {
    this.initialise();
  }

  initialise() {
    $.ajaxSetup({
      headers: {
        'X-CSRF-TOKEN': Core6Utilities.getJQueryElement('meta[name="csrf-token"]').prop('content'),
      },
    });

    const bookmark = window.location.hash;
    if (bookmark) {
      if (bookmark.indexOf('#component') === 0) {
        const componentToHighlight = bookmark.replace('#component', '');
        document.querySelector(`.core6_component${componentToHighlight}`).style.border = '5px solid #550000';
        document.querySelector(`.core6_component${componentToHighlight}`).style.backgroundColor = '#bd0000';
      }
    }

    //console.log('INITIALISE COMPONENT');

    Core6Utilities.getJQueryElement(document.body).on(
      'click',
      '.core6_admin_options_component_toggle a[data-core6-component-action]',
      {thisClass: this},
      Core6Component.componentButtonsListener,
    );

    Core6Utilities.getJQueryElement(document.body).on(
      'click',
      'a[data-core6-component-action="showMediaPicker"]',
      {thisClass: this},
      Core6Component.componentButtonsListener,
    );

    Core6Utilities.getJQueryElement(document.body).on(
      'click',
      'a[data-core6-component-action="showDownloadPicker"]',
      {thisClass: this},
      Core6Component.componentButtonsListener,
    );

    Core6Utilities.getJQueryElement(document.body).on(
      'click',
      'a[data-core6-component-action="showEditHTML"]',
      {thisClass: this},
      Core6Component.componentButtonsListener,
    );
  }

  static componentButtonsListener(evt) {
    //console.log('init component buttons');
    // Start up the component buttons
    //console.log('clicked!');
    const componentId = $(this).data('component-id');
    const rowId = $(this).data('row-id');
    const action = $(this).data('core6-component-action');

    switch (action) {
      case 'showEditHTML':
        const editHtmlModal = Core6Utilities.getJQueryElement(`.editHTMLModal[data-component-id=${componentId}]`);
        Core6Utilities.initDialogTabs();
        editHtmlModal.modal('show');
        editHtmlModal.find(`#editor_${componentId}`).next().focus();
        break;
      case 'showComponentOptions':
        const options = Core6Utilities.getJQueryElement(`.changeComponentOptionsModal[data-component-id=${componentId}]`);
        Core6Utilities.initDialogTabs();
        options.modal('show');
        //console.log(`show Component Options: ${componentId}`);
        break;
      case 'showComponentThemes':
        const theme = Core6Utilities.getJQueryElement(`.changeComponentThemeModal[data-component-id=${componentId}]`);
        Core6Utilities.initDialogTabs();
        theme.modal('show');
        //console.log(`show Component Themes: ${componentId}`);
        break;
      case 'showCloneConfirm':
        Core6Utilities.getJQueryElement(`.confirmComponentCloneModal[data-component-id=${componentId}]`).modal('show');
        Core6Utilities.initDialogTabs();
        //console.log(`show Component Clone Dialog: ${componentId}`);
        break;
      case 'showDeleteConfirm':
        Core6Utilities.getJQueryElement(`.confirmComponentDeleteModal[data-component-id=${componentId}]`).modal('show');
        Core6Utilities.initDialogTabs();
        //console.log(`show Component Delete Dialog: ${componentId}`);
        break;
      case 'showDownloadPicker':
        //console.log('show download picker');
        if (evt.type === 'click') {
          const downloadPicker = Core6Utilities.getJQueryElement('.downloadPickerModal');
          Core6Utilities.initDialogTabs();
          downloadPicker.modal('show');
          //console.log(`show Download Picker Dialog: ${componentId}`);
          downloadPicker.attr('data-component-id', componentId);
          downloadPicker.find('.btn-primary').attr('data-component-id', componentId);
          downloadPicker.find('.btn-primary').attr('data-row-id', rowId);

          const onShowEvent = new CustomEvent('ondownloadpickershow', {
            detail: {
              component_id: componentId,
              row_id: rowId,
            },
          });
          Core6Utilities.getElement('.downloadPickerModal').dispatchEvent(onShowEvent);
        }
        break;
      case 'showMediaPicker':
        if (evt.type === 'click') {
          //console.log('SHOW MEDIA PICKER');
          const currentImage = $(`[data-core6-component-action=showMediaPicker][data-component-id=${componentId}][data-row-id=${rowId}]`).attr('data-current_image');
          const mediaPickerModal = Core6Utilities.getJQueryElement('.mediaPickerModal');
          Core6Utilities.initDialogTabs();
          mediaPickerModal.modal('show');
          //console.log(`show Media Picker Dialog: ${componentId}`);
          mediaPickerModal.attr('data-component-id', componentId);
          mediaPickerModal.find('.btn-primary').attr('data-component-id', componentId);
          mediaPickerModal.find('.btn-primary').attr('data-row-id', rowId);
          mediaPickerModal.find('.flex-squares-container .core6_selected_image').removeClass('core6_selected_image');

          if (currentImage) {
            mediaPickerModal.find(`.flex-squares-container .thumbnail[data-value="${currentImage}"]`).addClass('core6_selected_image');
            // $('.mediaPickerModal .btn-primary').attr('data-value', current_image);
          } else {
            // $('.mediaPickerModal .btn-primary').attr('data-value', "");
          }

          const onShowEvent = new CustomEvent('onmediapickershow', {
            detail: {
              component_id: componentId,
              row_id: rowId,
              current_image: currentImage,
            },
          });
          Core6Utilities.getElement('.mediaPickerModal').dispatchEvent(onShowEvent);
        }
        break;
    }

    //console.log('preventDefault');
    evt.preventDefault();
  }


  static enableEditableFields() {
    const previewFrame = document.querySelector('#previewframe');
    let eventAnchor = null;
    if (previewFrame !== null && previewFrame !== undefined) {
      eventAnchor = previewFrame.contentWindow.document.body;
    } else {
      eventAnchor = document.body;
    }

    $(eventAnchor).on('click', '.core6_editableField', function () {
      //console.log('clicked core6_editableField');
      Core6Component.showTextEditor($(this));
    });

    $(eventAnchor).on('click', "button[name='save_component_param_edit']", function () {
      const component_id = $(this).data('component-id');
      const param = $(this).data('param');
      const row_id = $(this).data('row-id');
      let element,
        url;

      if (component_id == 0) {
        // it's a block...
        //console.log("it's a block...");
        //console.log(`.core6_editableField.isEditing[data-row-id="${row_id}"][data-param="${param}"]`);
        element = Core6Utilities.getJQueryElement(`.core6_editableField.isEditing[data-row-id="${row_id}"][data-param="${param}"]`);
        //console.log(element);
        url = '/api/save_row_attribute';
      } else {
        // it's a component
        element = Core6Utilities.getJQueryElement(`.core6_editableField.isEditing[data-component-id="${component_id}"][data-param="${param}"]`);
        url = '/api/save_component_attribute';
      }
      /* var element = $('.core6_editableField.isEditing[data-component-id="' + component_id + '"][data-param="' + param + '"]');
       var row_id = element.data('row-id'); */


      //console.log(`Save Clicked = ${row_id}`);
      const newContent = Core6Utilities.getJQueryElement(`[name='edit_${param}${component_id}']`).val();

      $.ajax({
        url: `${url}?_=${new Date().getTime()}`,
        type: 'POST',
        data: {
          _method: 'POST',
          component_id,
          param,
          value: newContent,
          row_id,
        },
        beforeSend(xhr) {
          xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
          xhr.setRequestHeader('Authorization', `Bearer ${document.getElementById('API_TOKEN').value}`);
        },
        error(xhr, status, errorText) {
          //console.log(errorText);
        },
        success(data) {
          if (component_id == 0) {
            const j = JSON.parse(data);
            element.html(j[0].value);
            //console.log('New Content: ');
            //console.log(j);
          } else {
            element.html(data);
            //console.log(`New Content: ${data}`);
          }
          element.removeClass('isEditing');
          // Core6Utils.equal_height_rows();

          const editor_panels = element.find('.editor_panel');
          const editorLen = editor_panels.length;

          for (let i = 0; i < editorLen; i++) {
            editor_panels[i].parentNode.removeChild(editor_panels[i]);
          }
        },
      });
      return true;
    });

    $(eventAnchor).on('click', "button[name='cancel_component_param_edit']", function () {
      const component_id = $(this).data('component-id');
      const param = $(this).data('param');
      const row_id = $(this).data('row-id');
      let element,
        url;

      if (component_id == 0) {
        // it's a block...
        //console.log("it's a block...");
        //console.log(`.core6_editableField.isEditing[data-row-id="${row_id}"][data-param="${param}"]`);
        element = Core6Utilities.getJQueryElement(`.core6_editableField.isEditing[data-row-id="${row_id}"][data-param="${param}"]`);
        //console.log(element);
        url = '/api/get_row_attribute';
      } else {
        // it's a component
        //console.log("it's a component...");
        //console.log(`.core6_editableField.isEditing[data-component-id="${component_id}"][data-param="${param}"]`);
        element = Core6Utilities.getJQueryElement(`.core6_editableField.isEditing[data-component-id="${component_id}"][data-param="${param}"]`);
        //console.log(element);
        url = '/api/get_component_attribute';
      }

      //console.log('Cancel Clicked');
      $.ajax({
        url,
        type: 'POST',
        data: {
          _method: 'POST', component_id, row_id, param,
        },
        beforeSend(xhr) {
          xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
          xhr.setRequestHeader('Authorization', `Bearer ${document.getElementById('API_TOKEN').value}`);
        },
        success(data) {
          element.html(data);
          //console.log(`Reverted Content: ${data}`);
          element.removeClass('isEditing');

          const editor_panels = element.find('.editor_panel');
          const editorLen = editor_panels.length;

          for (let i = 0; i < editorLen; i++) {
            editor_panels[i].parentNode.removeChild(editor_panels[i]);
          }
        },
      });
      return true;
    });
  }


  static showTextEditor(element) {
    const inContextModal = Core6Utilities.getJQueryElement('.inContextModal');
    const isEditing = Core6Utilities.getJQueryElement('.isEditing');
    inContextModal.modal('show');
    isEditing.removeClass('isEditing');

    if (!element.hasClass('isEditing')) {
      element.addClass('isEditing');

      const component_id = element.data('component-id');
      const param = element.data('param');
      const row_id = element.data('row-id');
      const value = element.html();

      inContextModal.find('.textEditor').html(`<textarea name='edit_${param}${component_id}' data-component-id='${component_id}' data-row-id='${row_id}' data-core6-editor='${param}' style='color: #000000;'>${
        value
        }</textarea>`);

      let lastContents = value;
      inContextModal.find('.textEditor textarea').summernote({
        focus: true,
        minHeight: null,
        maxHeight: null,
        toolbar: [
          ['style', ['bold', 'italic', 'underline', 'clear']],
          ['fontsize', ['fontsize']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['insert', ['link', 'picture']],
          ['table', ['table']],
          ['misc', ['codeview']],
        ],
        fontSizes: ['8', '10', '12', '14', '18', '24', '36', '48', '60', '72'],
        callbacks: {
          onBlur: function () {
            console.log('Editable area loses focus');
            console.log(lastContents);

            let url;
            if (component_id === 0 || component_id === '0') {
              Core6Utilities.getJQueryElement(`.isEditing[data-row-id="${row_id}"][data-component-id="${component_id}"][data-param="${param}"]`).html(lastContents);
              // core6_row.changeRowAttribute(row_id, param, contents, true);
              url = '/api/save_row_attribute';
            } else {
              Core6Utilities.getJQueryElement(`.isEditing[data-row-id="${row_id}"][data-component-id="${component_id}"][data-param="${param}"]`).html(lastContents);
              // core6_component.changeComponentAttribute(component_id, param, contents, row_id, false, true);
              url = '/api/save_component_attribute';
            }

            $.ajax({
              url: `${url}?_=${new Date().getTime()}`,
              type: 'POST',
              data: {
                _method: 'POST',
                component_id,
                param,
                value: lastContents,
                row_id,
              },
              beforeSend(xhr) {
                xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
                xhr.setRequestHeader('Authorization', `Bearer ${document.getElementById('API_TOKEN').value}`);
              },
              success(data) {
                //console.log(data);
              },
            });
          },
          onChange: function (contents, $editable) {
            lastContents = contents;
            if (component_id === 0 || component_id === '0') {
              Core6Utilities.getJQueryElement(`.isEditing[data-row-id="${row_id}"][data-component-id="${component_id}"][data-param="${param}"]`).html(contents);
            } else {
              Core6Utilities.getJQueryElement(`.isEditing[data-row-id="${row_id}"][data-component-id="${component_id}"][data-param="${param}"]`).html(contents);
            }
          },
        },
      });
    }
  }


  static deleteComponent(component_id) {
    const deleteModal = Core6Utilities.getJQueryElement(`.confirmComponentDeleteModal[data-component-id=${component_id}]`);
    deleteModal.modal('hide');

    $.ajax({
      url: '/api/delete_component',
      type: 'DELETE',
      data: {_method: 'DELETE', component_id},
      beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-TOKEN', Core6Utilities.getJQueryElement('meta[name="csrf-token"]').attr('content'));
        xhr.setRequestHeader('Authorization', `Bearer ${document.getElementById('API_TOKEN').value}`);
      },
      success(data) {
        const component = Core6Utilities.getJQueryElement(`.core6_component${component_id}`);
        component.remove();

        Core6Utilities.modalCleanup();

        setTimeout(() => {
          const event = new Event('componentDeleted');
          document.dispatchEvent(event);
        }, 200);
      },
    });
  }


  static cloneComponent(component_id, row_id) {
    Core6Utilities.getJQueryElement(`.confirmComponentCloneModal[data-component-id=${component_id}]`).modal('hide');

    $.ajax({
      url: '/api/clone_component',
      type: 'PUT',
      data: {_method: 'PUT', row_id, component_id},
      beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-TOKEN', Core6Utilities.getJQueryElement('meta[name="csrf-token"]').attr('content'));
        xhr.setRequestHeader('Authorization', `Bearer ${document.getElementById('API_TOKEN').value}`);
      },
      success(data) {

        const component = Core6Utilities.getJQueryElement(`.core6_component${component_id}`);
        $(data).insertAfter(component);

        // Core6Utils.equal_height_rows();
        Core6Utilities.refreshDialogs();
        Core6Utilities.refreshCSS();

        //console.log('CALLING POSITIONED');
        setTimeout(() => {
          const event = new Event('componentAdded');
          document.dispatchEvent(event);
        }, 200);
      },
    });
  }

  static initFeatureAndButtonUrls() {
    //console.log('initFeatureAndButtonUrls');

    const featureUrls = Core6Utilities.getElementAll('select[name="feature_url_type"]');
    //console.log(featureUrls);
    for (let i = 0; i < featureUrls.length; i += 1) {
      const currentFeatureUrl = featureUrls[i];
      const componentId = currentFeatureUrl.getAttribute('data-component-id');
      const rowId = currentFeatureUrl.getAttribute('data-row-id');
      const value = currentFeatureUrl.value;
      Core6Component.featureUrlLogic(componentId, rowId, false, 'feature_url_type', value, true);
    }

    const buttonUrls = Core6Utilities.getElementAll('select[name="button_url_type"]');
    for (let i = 0; i < buttonUrls.length; i += 1) {
      const currentButtonUrl = buttonUrls[i];
      const componentId = currentButtonUrl.getAttribute('data-component-id');
      const rowId = currentButtonUrl.getAttribute('data-row-id');
      const value = currentButtonUrl.value;
      Core6Component.buttonUrlLogic(componentId, rowId, false, 'button_url_type', value, true);
    }
  }

  static featureUrlLogic(componentId, rowId, resetSlider, param, value, noUpdate) {
    const featureUrlCustom = Core6Utilities.getJQueryElement(`.feature_url_custom[data-component-id="${componentId}"]`);
    const featureUrlPage = Core6Utilities.getJQueryElement(`.feature_url_page[data-component-id="${componentId}"]`);
    const featureUrlDownload = Core6Utilities.getJQueryElement(`.feature_url_download[data-component-id="${componentId}"]`);

    //console.log('featureUrlLogic: componentId - ' + componentId);
    //console.log('featureUrlLogic: rowId - ' + rowId);
    //console.log('featureUrlLogic: param - ' + param);
    //console.log('featureUrlLogic: value - ' + value);

    if (param === 'feature_url_type') {
      switch (value) {
        case 'none':
          //console.log('featureUrlLogic: none logic');
          //console.log(featureUrlCustom);
          //console.log(featureUrlPage);
          //console.log(featureUrlDownload);
          featureUrlCustom.hide();
          featureUrlPage.hide();
          featureUrlDownload.hide();
          featureUrlCustom.find('input').val('');
          /*if (noUpdate === undefined) {
            this.changeComponentAttribute(componentId, 'feature_url', '', rowId, resetSlider);
          }*/
          break;
        case 'page':
          featureUrlCustom.hide();
          featureUrlPage.show();
          featureUrlDownload.hide();
          break;
        case 'download':
          featureUrlCustom.hide();
          featureUrlPage.hide();
          featureUrlDownload.show();
          break;
        case 'other':
          featureUrlCustom.show();
          featureUrlPage.hide();
          featureUrlDownload.hide();
          break;
      }
    }

    if (param === 'feature_url_download') {
      featureUrlCustom.find('input').val(value);
      //this.changeComponentAttribute(componentId, 'feature_url', value, rowId, resetSlider);
    }

    if (param === 'feature_url_page') {
      featureUrlCustom.find('input').val(value);
      //this.changeComponentAttribute(componentId, 'feature_url', value, rowId, resetSlider);
    }
  }

  static buttonUrlLogic(componentId, rowId, resetSlider, param, value, noUpdate) {
    const buttonUrlCustom = Core6Utilities.getJQueryElement(`.button_url_custom[data-component-id="${componentId}"]`);
    const buttonUrlPage = Core6Utilities.getJQueryElement(`.button_url_page[data-component-id="${componentId}"]`);
    const buttonUrlDownload = Core6Utilities.getJQueryElement(`.button_url_download[data-component-id="${componentId}"]`);

    if (param === 'button_url_type') {
      switch (value) {
        case 'none':
          buttonUrlCustom.hide();
          buttonUrlPage.hide();
          buttonUrlDownload.hide();
          buttonUrlCustom.find('input').val('');
          /*if (noUpdate === undefined) {
            this.changeComponentAttribute(componentId, 'button_url', '', rowId, resetSlider);
          }*/
          break;
        case 'page':
          buttonUrlCustom.hide();
          buttonUrlPage.show();
          buttonUrlDownload.hide();
          break;
        case 'download':
          buttonUrlCustom.hide();
          buttonUrlPage.hide();
          buttonUrlDownload.show();
          break;
        case 'other':
          buttonUrlCustom.show();
          buttonUrlPage.hide();
          buttonUrlDownload.hide();
          break;
      }
    }

    if (param === 'button_url_download') {
      buttonUrlCustom.find('input').val(value);
      //this.changeComponentAttribute(componentId, 'button_url', value, rowId, resetSlider);
    }

    if (param === 'button_url_page') {
      buttonUrlCustom.find('input').val(value);
      //this.changeComponentAttribute(componentId, 'button_url', value, rowId, resetSlider);
    }
  }


  static changeComponentAttributes(componentId, queue, rowId) {
    //console.log(queue);

    const paramData = {
      _method: 'POST',
      rowId,
      componentId,
      queue
    };

    //console.log(paramData);

    $.ajax({
      url: `/api/save_component_attributes?_=${new Date().getTime()}`,
      type: 'POST',
      data: paramData,
      beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
        xhr.setRequestHeader('Authorization', `Bearer ${document.getElementById('API_TOKEN').value}`);
      },
      success(data) {
        Core6Utilities.replaceComponentLoader(componentId, data);

        Core6Utilities.getElement('.core_loading_anim_container').style.display = 'none';
      },
    });
  }


  static changeComponentAttribute(componentId, param, value, rowId, resetSlider = false, liveUpdateDone = false) {
    //console.log('change here?');

    if (param === 'feature_url_type' || param === 'feature_url_download' || param === 'feature_url_page') {
      Core6Component.featureUrlLogic(componentId, rowId, resetSlider, param, value);
    }

    if (param === 'button_url_type' || param === 'button_url_download' || param === 'button_url_page') {
      Core6Component.buttonUrlLogic(componentId, rowId, resetSlider, param, value);
    }

    // fix for the image selector
    if (param === 'image') {
      componentId = Core6Utilities.getJQueryElement('[data-core6-component-action=selectImage]').attr('data-component-id');
      value = Core6Utilities.getJQueryElement('[data-core6-component-action=selectImage]').attr('data-value');
      rowId = Core6Utilities.getJQueryElement('[data-core6-component-action=selectImage]').attr('data-row-id');
      //console.log(`Changing ${param} to ${value} on component_id: ${componentId}`);

      Core6Utilities.getJQueryElement(`a[data-core6-component-action="showMediaPicker"][data-component-id="${componentId}"]`).attr('data-current_image', value);
      Core6Utilities.getJQueryElement(`a[data-core6-component-action="showMediaPicker"][data-component-id="${componentId}"] > .feature_image_holder`).attr('data-core6_slider_images', value);
    }

    $.ajax({
      url: `/api/save_component_attribute?_=${new Date().getTime()}`,
      type: 'POST',
      data: {
        _method: 'POST', component_id: componentId, param, value, row_id: rowId,
      },
      beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-TOKEN', Core6Utilities.getJQueryElement('meta[name="csrf-token"]').attr('content'));
        xhr.setRequestHeader('Authorization', `Bearer ${document.getElementById('API_TOKEN').value}`);

        if (liveUpdateDone === false) {
          switch (param) {
            case 'image':
              break;
            case 'horizontal_align' :
              break;
            case 'vertical_align' :
              break;
            case 'theme':
              Core6Utilities.getJQueryElement(`.core6_component${componentId}_holder`).html('');
              Core6Utilities.getJQueryElement(`.core6_component${componentId}_holder`).addClass('core_6_loader');
              break;
            default:
              Core6Utilities.getJQueryElement(`.core6_component${componentId}_holder`).html('');
              Core6Utilities.getJQueryElement(`.core6_component${componentId}_holder`).addClass('core_6_loader');
              break;
          }
        }
      },
      success(data) {
        // Core6Utilities.getJQueryElement('.core6-mainrow-container[data-row-id='+row_id+']').replaceWith(data);

        if (liveUpdateDone === false) {
          switch (param) {
            case 'image':
              //console.log(`Updating: '.core6_component${componentId}_holder .feature_image_holder'`);
              const imageHolder = Core6Utilities.getJQueryElement(`.core6_component${componentId}_holder .feature_image_holder`);
              if (data === '') {
                imageHolder.css('background-image', 'none');
              } else {
                imageHolder.css('background-image', `url(${data})`);
                imageHolder.css('background-size', '');
                imageHolder.css('background-color', '');
              }
              break;
            case 'theme':
              Core6Utilities.replaceComponentLoader(componentId, data);
              /*Core6Utilities.getJQueryElement(`.core6_component${componentId}_holder`).removeClass('core_6_loader');
              Core6Utilities.getJQueryElement(`.core6_component${componentId}_holder`).html(data);
              Core6Utilities.refreshCSS();*/
              break;
            case 'horizontal_align' :
              Core6Utilities.refreshCSS();
              break;
            case 'vertical_align' :
              Core6Utilities.refreshCSS();
              break;
            default:
              //console.log('default');
              Core6Utilities.replaceComponentLoader(componentId, data);
              /*
                            Core6Utilities.getJQueryElement(`.core6_component${componentId}_holder`).removeClass('core_6_loader');
                            Core6Utilities.getJQueryElement(`.core6_component${componentId}_holder`).html(data);
                            Core6Utilities.refreshCSS();*/
              break;
          }
        }

        if (param === 'scroll_time' || param === 'transition' || param === 'scroll_numbers' || param === 'scroll_arrows') {
          resetSlider = true;
        }

        // Core6Utils.equal_height_rows();

        if (resetSlider === true) {
          const onSliderResetEvent = new CustomEvent('onsliderreset', {detail: {}});
          document.querySelector('body').dispatchEvent(onSliderResetEvent);
        }
      },
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6Component.js